import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function PdfIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 12 13'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.792893 0.792893C0.980429 0.605357 1.23478 0.5 1.5 0.5H7.5C7.63261 0.5 7.75979 0.552678 7.85355 0.646447L11.3536 4.14645C11.4473 4.24021 11.5 4.36739 11.5 4.5V7C11.5 7.27614 11.2761 7.5 11 7.5C10.7239 7.5 10.5 7.27614 10.5 7V4.70711L7.29289 1.5L1.5 1.5L1.5 7C1.5 7.27614 1.27614 7.5 1 7.5C0.723858 7.5 0.5 7.27614 0.5 7V1.5C0.5 1.23478 0.605357 0.980429 0.792893 0.792893Z'
        fill='#3B3C40'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.5 0.5C7.77614 0.5 8 0.723858 8 1V4H11C11.2761 4 11.5 4.22386 11.5 4.5C11.5 4.77614 11.2761 5 11 5H7.5C7.22386 5 7 4.77614 7 4.5V1C7 0.723858 7.22386 0.5 7.5 0.5Z'
        fill='#3B3C40'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.5 9.5C0.5 9.22386 0.723858 9 1 9H2C2.39783 9 2.77936 9.15804 3.06066 9.43934C3.34196 9.72064 3.5 10.1022 3.5 10.5C3.5 10.8978 3.34196 11.2794 3.06066 11.5607C2.77936 11.842 2.39783 12 2 12H1.5V12.5C1.5 12.7761 1.27614 13 1 13C0.723858 13 0.5 12.7761 0.5 12.5V9.5ZM1.5 11H2C2.13261 11 2.25978 10.9473 2.35355 10.8536C2.44732 10.7598 2.5 10.6326 2.5 10.5C2.5 10.3674 2.44732 10.2402 2.35355 10.1464C2.25978 10.0527 2.13261 10 2 10H1.5V11Z'
        fill='#3B3C40'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.25 9.5C9.25 9.22386 9.47386 9 9.75 9H11.5C11.7761 9 12 9.22386 12 9.5C12 9.77614 11.7761 10 11.5 10H10.25V12.5C10.25 12.7761 10.0261 13 9.75 13C9.47386 13 9.25 12.7761 9.25 12.5V9.5Z'
        fill='#3B3C40'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.25 11.25C9.25 10.9739 9.47386 10.75 9.75 10.75H11.25C11.5261 10.75 11.75 10.9739 11.75 11.25C11.75 11.5261 11.5261 11.75 11.25 11.75H9.75C9.47386 11.75 9.25 11.5261 9.25 11.25Z'
        fill='#3B3C40'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.625 9.5C4.625 9.22386 4.84886 9 5.125 9H6C6.53043 9 7.03914 9.21071 7.41421 9.58579C7.78929 9.96086 8 10.4696 8 11C8 11.5304 7.78929 12.0391 7.41421 12.4142C7.03914 12.7893 6.53043 13 6 13H5.125C4.84886 13 4.625 12.7761 4.625 12.5V9.5ZM5.625 10V12H6C6.26522 12 6.51957 11.8946 6.70711 11.7071C6.89464 11.5196 7 11.2652 7 11C7 10.7348 6.89464 10.4804 6.70711 10.2929C6.51957 10.1054 6.26522 10 6 10H5.625Z'
        fill='#3B3C40'
      />
    </SvgIcon>
  );
}
